module.exports = __webpack_public_path__ + "static/media/analytics-light.1a388dfc.svg";